import React from "react";
import PropTypes from "prop-types";
import { component_tool, framework_tool } from "@/tool";
const { WizContainer } = framework_tool;
import { Row, Col, Layout, Button, Icon, Input, Spin, message } from 'antd';
const { WizButton,WizRow,WizCol,WizSurveyAudience } = component_tool;
import { Table, Form } from "antd";
import { WizTableForm } from "@/containers/common";

class ContentType extends WizContainer {
  componentName = "ContentType";

  constructor(props) {
    super(props);
    this.state = {
      value: props.value || [],
      record: 0,
      formVisible:false,
      authData:{orgIds:[],personIds:[],positionCategoryIds:[],positionIds:[]},
      count: 0
    }
  }

  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func,
  };

  _componentDidMount(){
    const { value,onChange } = this.props
    if(value){
    this.setState({
      count: 1
    },()=>{
      onChange && onChange(value)
    })
  }
  }

  // 生命周期钩子函数
  _componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  // 过滤“关联考试模版”的值
  formatVals = vals => {
    return vals
    // if(vals && vals.length){
    //   return vals.filter(val => val.templateName !== '请选择考试模版').filter(val => val.positionNames !== '请选择岗位对象')
    // }
    // return []
  }

  // 删除行
  handleDelete = key => {
    const { onChange } = this.props
    this.setState({
        count: 0
    },()=>{
      onChange && onChange(null)
    });
  };

  // 添加行
  handleAdd = () => {
    this.setState({
      //count: count + 1,
      formVisible:true,
    },()=>{
      //onChange && onChange(0)
    });
  };

  // 保存行数据
  handleSave = row => {

  };
  _renderBtn = (value, valueRows) => {
    return (
    <WizButton
    icon="plus"
    type="primary"
    onClick={() => this.handleAdd()}
    style={{marginTop: 15, marginBottom: 15}}>
        添加
      </WizButton>
    )
  }

  _formSubmit= (obj, e) => {
    const { onChange } = this.props
    const { count} = this.state;
    let id = 0
    let authData = {orgIds:[],personIds:[],positionCategoryIds:[],positionIds:[]}
    if(obj&&obj['value']){
      id = obj['value']
      authData = obj['valueRows']['authData'] ||authData
    }
    this.setState({
        formVisible: false,
        authData:authData,
        count: count + 1,
    },()=>{
        onChange && onChange(id)
      });
  }
  _formCancel = (obj, e) => {
    this.setState({
        formVisible: false,
    });
  }

  _render() {
    const { config,bizName } = this.props;
    const { count,formVisible,record,authData } = this.state;
    return (
      <React.Fragment>
        {count>=1?
        //<Spin tip={'加载中'} spinning={examLoading}>
            <>
        <WizButton icon='delete' type="danger" onClick={() => this.handleDelete()}>
          删除
        </WizButton>
            {/* <WizSurveyAudience data={authData} labelWidth={4} /> */}

            <WizRow>
                <WizCol span={24} style={{ textAlign: 'left' }}>
                  场景名称：{bizName}
                </WizCol>
            </WizRow>
        </>
        :<WizTableForm key={record} {...config} showModal={true} visible={formVisible}
        selectType={'radio'}
        //initRows={null} value={null}
        onSubmit={this._formSubmit}
        onCancel={this._formCancel}
        renderValue={this._renderBtn}
/>}

      </React.Fragment>
    );
  }
}




ContentType.validator = (rule, value, callback) => {
  if (value ) {
  callback()
  return
  }else{
    callback('请添加关联业务')
    return
  }
  callback()
}

export default ContentType
